import { useQuery } from '@tanstack/react-query';
import api from '@/components/takeoff/api';
import { defaultCurrencySettings } from '@/reducers/product-management';

export type Currency = (typeof defaultCurrencySettings)['currency'];

// Query key factory for currency
export const currencyKeys = {
  all: ['currency'] as const,
  org: () => [...currencyKeys.all, 'org'] as const,
};

// Hook to fetch organization currency settings
export const useCurrencyQuery = () => {
  return useQuery({
    queryKey: currencyKeys.org(),
    queryFn: async () => {
      const res = await api.queryOrgTakeoffSetting();
      if (res.count != 0) {
        return res.result[0].currency;
      }
      return defaultCurrencySettings['currency'];
    },
    refetchOnWindowFocus: false,
  });
};
